import { memo, useCallback, useEffect, useState } from 'react';
import { BzModal, BzModalBody, BzModalHeader } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { handleModal } from '../../redux/actions/modals';
import { getDyanmicURL, searchLocalStorage } from '../../utils/global_functions';
import { HAMBURGER_LIST, LINK_OPEN_MODES } from '../../utils/global_variables';
import { updateDynamicMenus, updateInAppIFrame } from '../../redux/actions/appInfo';
import { ssoLink } from '../../apis/cdn_service';
import { getExchangeLinks } from '../../apis/nontransactional';


const SSOLinksModal = ({handleAddendumClik}) => {
    const dispatch = useDispatch();
    const modals = useSelector(state => state.modals.modals);
    const objModalData = useSelector(state => state?.modals?.modalData);
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    const objDashMenu = useSelector(state => state.appInfo?.dynamicMenus)
    const [objData,setObjData] = useState([])


    const fetchSsoData = async ()=>{
        const ssoLinkData = await ssoLink() 
        let ssoLinkIndex = objDashMenu?.hamburgerMenu?.items.findIndex(it => it.id === 305); 
        if (ssoLinkData?.data && ssoLinkIndex >= 0) {
            setObjData(ssoLinkData?.data)
            objDashMenu.hamburgerMenu.items[ssoLinkIndex].childs = [...ssoLinkData?.data];
            let objResp = objDashMenu
            dispatch(updateDynamicMenus(objResp));
        } 
    }

    const fetchExchangeLinks = async ()=>{
         let  exchangeLinksData = await getExchangeLinks();
       const exchangeLinksDataTransformed = exchangeLinksData.data.result.map((link, index) => {
        const { sLinkTitle, sLinkDescription, sLinkAddress, sLinkMode } = link;

        return {
            id: String(index + 1),
            iconurl: '',
            menuname: sLinkTitle,
            isExchangeLink: true,
            description: sLinkDescription,
            menuUrl: sLinkAddress,
            opentype: sLinkMode
        };
    });
    setObjData(exchangeLinksDataTransformed)
    let linkIndex = objDashMenu?.hamburgerMenu?.items.findIndex(it => it.id === 306);
    if (exchangeLinksDataTransformed && linkIndex >= 0) {
        objDashMenu.hamburgerMenu.items[linkIndex].childs = [...exchangeLinksDataTransformed];
    } 
    let objResp = objDashMenu
    dispatch(updateDynamicMenus(objResp));
    }
    

    useEffect(()=>{
     if(!objModalData?.data?.length && objModalData.name === HAMBURGER_LIST.SSO_LINKS ){
        fetchSsoData()
     }else if(!objModalData?.data?.length && objModalData.name === HAMBURGER_LIST.EXCHANGE_LINKS){
        fetchExchangeLinks()
     }
    },[objModalData])

    // { /* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - Start */ }
    const handleClose = () => {
        dispatch(handleModal([{ 'SSO_LINK_MODAL': false }]));
    };
    // { /* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - End */ }

    // { /* BT-121004 : Vinit Raut : 06-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - Start */ }
    const handleOnClick = useCallback((obj) => {
        let link
        if (obj?.name === "addendum&notices") {
            let path = obj?.menuUrl;
            dispatch(handleModal([{ 'SSO_LINK_MODAL': false }]));
            handleAddendumClik(path);
            
        } else {
            if(objModalData?.id === 304 || objModalData?.id === 404 || objModalData?.id === 306){
              link = obj?.menuUrl 
            }else if(objModalData?.id === 305){
                link = obj?.action?.url 
            }
            let URL;
                URL = getDyanmicURL({ url: link }, objLoginSession, true);
            if (URL) {
                if (obj?.opentype === LINK_OPEN_MODES.IFRAME) {
                    dispatch(handleModal([{ 'SSO_LINK_MODAL': false }]));
                    dispatch(updateInAppIFrame({ url: URL, title: obj?.menuname }));
                    dispatch(handleModal([{ "IN_APP_IFRAME": true }], true));
                } else {
                    window.open(URL);
                }
            } else { }
        }


    }, [dispatch,handleAddendumClik, objLoginSession]);
    // { /* BT-121004 : Vinit Raut : 06-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - End */ }

    return (
        <BzModal centered size="lg" show={modals['SSO_LINK_MODAL']} onHide={handleClose}>
            <BzModalHeader className='modaltabs-header modal-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size4 color-text'>{objModalData?.header}</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={handleClose}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        {(objData?.length > 0 ? objData : objModalData?.data).map(obj => {
                            return (
                                <Col md={4} key={obj?.menuname} onClick={() => { handleOnClick(obj); }}>
                                    <div className='sso-card-wrapper'>
                                        <div className='sso-cards'>
                                            <Container fluid className='p-0'>
                                                <Row className='g-0'>
                                                    <Col md={11} className='d-flex flex-column justify-content-end align-items-start'>
                                                        <div className='font-medium font-size2 color-primary text-break'>{obj?.menuname}</div>
                                                        <div className='font-regular font-size1 color-subtext text-break'>{obj?.description}</div>
                                                    </Col>
                                                    <Col md={1} className='d-flex justify-content-end align-items-start'>
                                                        <div className='icon-10 icon-arrowright icon-dark'></div>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </div>
                                    </div>
                                </Col>
                            );
                            })}
                    </Row>
                </Container>
            </BzModalBody>
        </BzModal >

    );
};

export default memo(SSOLinksModal);